import React from 'react';
import type { RedcatIconProps } from './RedcatIcon';
import { REDCAT_ICON_DEFAULT_COLOR, REDCAT_ICON_DEFAULT_SIZE } from './RedcatIcon';

const RedcatMapPinHomeIcon = ({
  size = REDCAT_ICON_DEFAULT_SIZE,
  color = REDCAT_ICON_DEFAULT_COLOR,
}: RedcatIconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 13.2H10.9V9.9H13.3V13.2H15.7V7.5L12.1 5.1L8.5 7.5V13.2ZM12.1 20.82C14.54 18.58 16.35 16.545 17.53 14.715C18.71 12.885 19.3 11.26 19.3 9.84C19.3 7.66 18.605 5.875 17.215 4.485C15.825 3.095 14.12 2.4 12.1 2.4C10.08 2.4 8.375 3.095 6.985 4.485C5.595 5.875 4.9 7.66 4.9 9.84C4.9 11.26 5.49 12.885 6.67 14.715C7.85 16.545 9.66 18.58 12.1 20.82ZM12.1 24C8.88 21.26 6.475 18.715 4.885 16.365C3.295 14.015 2.5 11.84 2.5 9.84C2.5 6.84 3.465 4.45 5.395 2.67C7.325 0.89 9.56 0 12.1 0C14.64 0 16.875 0.89 18.805 2.67C20.735 4.45 21.7 6.84 21.7 9.84C21.7 11.84 20.905 14.015 19.315 16.365C17.725 18.715 15.32 21.26 12.1 24Z"
        fill={color}
      />
    </svg>
  );
};

export default RedcatMapPinHomeIcon;
